!function() {
  "use strict";
  customElements.get("location-selector") || customElements.define("location-selector", class extends HTMLElement {
    form=this.querySelector("form");
    constructor() {
      super();
    }
    onSubmitHandler(e) {
      e?.preventDefault(), window.Geo.setGeolocationCookie({
        handle: this.querySelector('[name="country_code"]').selectedOptions[0].value,
        name: this.querySelector('[name="country_code"]').selectedOptions[0].textContent
      }), window.dataLayer.push({
        event: "announcement_banner",
        click_action: `Region Select - ${e.target.value}`
      }), this.form.submit();
    }
    connectedCallback() {
      this.form && (this.form.addEventListener("submit", (e => this.onSubmitHandler(e))), 
      this.form.addEventListener("change", (e => this.onSubmitHandler(e))));
    }
  });
}();